import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function MobileAppDevelopment() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Mobile App Development</h1>
        <p>Native and cross-platform mobile apps for iOS and Android.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Capabilities</h3>
          <ul>
            <li>React Native & Flutter development</li>
            <li>Native iOS/Android development</li>
            <li>App store submission and maintenance</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Start Mobile Project</a>
        </div>
      </div>
    </div>
  );
}

export default MobileAppDevelopment;
